// @flow

import { values } from 'lodash';
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

const getErrorMessage = 'Could not get data';
const submitErrorMessage = 'Failed to Submit';

export const documentCheckerActions = {
  GET_DOCUMENT_CHECKER_DATA: 'GET_DOCUMENT_CHECKER_DATA',
  SET_DOCUMENT_CHECKER_DATA: 'SET_DOCUMENT_CHECKER_DATA',
  GET_FILTERS_DATA: 'GET_FILTERS_DATA',
  SET_FILTERS_DATA: 'SET_FILTERS_DATA',
  SET_LOADING_DATA: 'SET_LOADING_DATA',
  SET_CLIENT_FILTER_DATA: 'SET_CLIENT_FILTER_DATA',
  UPDATE_CONSIGNMENT_BY_INDEX: 'UPDATE_CONSIGNMENT_BY_INDEX'
};

export const updateConsignmentByIndex = payload => ({
  type: documentCheckerActions.UPDATE_CONSIGNMENT_BY_INDEX,
  payload
});

export const getFiltersData = payload => ({
  type: documentCheckerActions.GET_FILTERS_DATA,
  payload: payload
});

export const setFiltersData = payload => ({
  type: documentCheckerActions.SET_FILTERS_DATA,
  payload: payload
});

export const getDocumentCheckerDataAction = payload => ({
  type: documentCheckerActions.GET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setDocumentCheckerDataAction = payload => ({
  type: documentCheckerActions.SET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setLoadingData = payload => ({
  type: documentCheckerActions.SET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setClientFilter = payload => ({
  type: documentCheckerActions.SET_CLIENT_FILTER_DATA,
  payload
});

const removeToastr = () => {
  toastr.removeByType('error');
  toastr.removeByType('warning');
  toastr.removeByType('light');
};

const toastrOptions = {
  timeOut: 0
};

export const getConsignmentDetails = data => dispatch => {
  dispatch(
    getDocumentCheckerDataAction({
      isLoading: true,
      isLoaded: false,
      consignmentData: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDocumentCheckerDocuments',
    method: 'POST',
    data: data,
    pathVariables: [{ key: 'docType', val: 'POD' }],

    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (res.errorMessage) {
          dispatch(
            getDocumentCheckerDataAction({
              isLoading: false,
              isLoaded: true,
              consignmentData: [],
              error: res.errorMessage
            })
          );
        } else {
          let updatedConsignments = [];
          if (res && res.payload && res.payload.documentConfigurationData) {
            updatedConsignments = [...res.payload.documentConfigurationData];
          }
          updatedConsignments.map(consignment => {
            consignment.displayAddRemarksBox = false;
          });
          dispatch(
            getDocumentCheckerDataAction({
              isLoading: false,
              isLoaded: true,
              consignmentData: updatedConsignments,
              error: null
            })
          );
        }
        removeToastr();
        toastr.success('Success', `Details Fetched Sucessfully`);
        if (
          res &&
          res.payload &&
          res.payload.documentConfigurationData &&
          data &&
          data.cnotes &&
          res.payload.documentConfigurationData.length < data.cnotes.length
        ) {
          toastr.light(
            'Warning',
            'Some entered CN(s) are not eligible for POD Document Checker',
            {
              status: 'warning',
              timeOut: 0
            }
          );
        }
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDocumentCheckerDataAction({
            isLoading: false,
            isLoaded: true,
            consignmentData: [],
            error: res.errorMessage || getErrorMessage
          })
        );
        removeToastr();
        toastr.error(
          'Error',
          'Failed to fetch Consignment Details',
          toastrOptions
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDocumentCheckerDataAction({
          isLoading: false,
          isLoaded: true,
          consignmentData: [],
          error: res.errorMessage || getErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        'Failed to fetch Consignment Details',
        toastrOptions
      );
    },
    catchCb: res => {
      dispatch(
        getDocumentCheckerDataAction({
          isLoading: false,
          isLoaded: true,
          consignmentData: {},
          error: 'Failed to fetch Consignment Details'
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        'Failed to fetch Consignment Details',
        toastrOptions
      );
    }
  };

  return makeApiCall(requestObj);
};

export const updateConsignment = (consignmentIndx, consignment) => dispatch => {
  dispatch(
    updateConsignmentByIndex({
      index: consignmentIndx,
      consignment: consignment
    })
  );
};

export const getAllFilters = (apiToUseForClientFilter, userId) => dispatch => {
  dispatch(
    getFiltersData({
      isLoading: true,
      isLoaded: false,
      consignmentData: [],
      filterData: [],
      error: null
    })
  );

  Promise.all([
    getDocumentCheckerFilters()
    //getClientsListFilter(apiToUseForClientFilter, userId)
  ])
    .then(values => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: null
        })
      );

      if (values.length > 0) {
        if (values[0].status === 'SUCCESS') {
          dispatch(getFiltersData({ filterData: values[0].payload }));
          removeToastr();
        } else if (values[0].status === 'FAILURE') {
          dispatch(
            getFiltersData({
              consignmentData: [],
              filterData: [],
              error: values[0].errorMessage || getErrorMessage
            })
          );
          removeToastr();
          toastr.error(
            'Error',
            'Failed to fetch Filters Details',
            toastrOptions
          );
        } else {
          dispatch(
            getFiltersData({
              error: getErrorMessage
            })
          );
        }
      }
    })
    .catch(() => {
      dispatch(
        setFiltersData({
          isLoading: false,
          isLoaded: true,
          consignmentData: [],
          filterData: [],
          clientFilterData: [],
          error: getErrorMessage
        })
      );
      dispatch(setClientFilter([]));
      removeToastr();
      toastr.error('Error', 'Failed to fetch Filters Details', toastrOptions);
    });
};

const getDocumentCheckerFilters = dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDocumentcheckerFilters',
    method: 'GET',
    pathVariables: [{ key: 'docType', val: 'POD' }]
  };

  return makeApiCall(requestObj);
};

export const getClientsFilter = searchString => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClients',
    replaceParamsArr: [
      { key: 'searchString', val: encodeURIComponent(searchString) || '' }
    ]
  };

  makeApiCall(requestObj)
    .then(res => {
      if (res.status === 'SUCCESS') {
        const responseList = res.payload || [];
        dispatch(setClientFilter({ clientFilterData: responseList }));
      } else if (res.status === 'FAILURE') {
        dispatch(setClientFilter([]));
      } else {
        dispatch(setClientFilter([]));
      }
    })
    .catch(() => {
      dispatch(setClientFilter([]));
      removeToastr();
    });
};

export const approveORAddRemarksConsignment = (
  data,
  callback,
  consignment,
  consignmentIndx
) => dispatch => {
  dispatch(
    setLoadingData({
      isLoading: true,
      isLoaded: false,
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'consignmentDocumentChecker',
    method: 'PUT',
    replaceParamsArr: [
      { key: 'docType', val: data.docType },
      { key: 'cnote', val: data.cnote },
      { key: 'documentFileIds', val: data.documentFileIds }
    ],
    data: data.data,

    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          setLoadingData({
            isLoading: false,
            isLoaded: true,
            error: null
          })
        );
        const updatedConsignment = { ...consignment };
        updatedConsignment.actionTaken = data.data.actionTaken;
        updatedConsignment.displayAddRemarksBox = false;
        dispatch(
          updateConsignmentByIndex({
            consignment: updatedConsignment,
            index: consignmentIndx
          })
        );
        if (callback) {
          callback();
        }
        removeToastr();
        toastr.success('Success', `Successfully submitted`);
      } else if (res.status === 'FAILURE') {
        dispatch(
          setLoadingData({
            isLoading: false,
            isLoaded: true,
            error: null
          })
        );
        removeToastr();
        toastr.error(
          'Error',
          res.errorMessage || submitErrorMessage,
          toastrOptions
        );
      }
    },
    failureCb: res => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: res.errorMessage || submitErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        res.errorMessage || submitErrorMessage,
        toastrOptions
      );
    },
    catchCb: res => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: res.errorMessage || submitErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        res.errorMessage || submitErrorMessage,
        toastrOptions
      );
    }
  };

  return makeApiCall(requestObj);
};
